import { Mock } from '@mock/models';
import { listSubscriptionPlansMock } from '@mock/schema/dashboard/subscription-plans.mock';
import { readMeUsersMock } from '@mock/schema/users/read.me.users.mock';

export const mock: Mock[] = [
  {
    url: 'users/me',
    schema: readMeUsersMock(),
  },
  // {
  //   method: 'POST',
  //   url: 'images/generate',
  //   schema: createImageGenerateMock(),
  //   delay: 2000,
  // },
  // {
  //   method: 'POST',
  //   url: 'videos/generate',
  //   schema: createVideoGenerateMock(),
  //   status: 429,
  //   delay: 5000,
  // },
  // --- Dashboard ---
  {
    url: 'subscriptions/plans',
    apiEndpoint: 'evoqAdmin',
    schema: listSubscriptionPlansMock(),
    delay: 300,
  },
  // {
  //   url: 'managers/me/stores',
  //   apiEndpoint: 'evoqAdmin',
  //   schema: listStoresMock(),
  //   useStartsWith: true,
  //   delay: 300,
  // },
  // {
  //   url: 'managers/me',
  //   apiEndpoint: 'evoqAdmin',
  //   schema: readMeManagersMock(),
  //   delay: 500,
  // },
  // {
  //   url: 'vendors',
  //   apiEndpoint: 'evoqAdmin',
  //   schema: listVendorsMock(),
  //   delay: 500,
  // },
  // {
  //   method: 'PATCH',
  //   url: 'vendors/quotas',
  //   apiEndpoint: 'evoqAdmin',
  //   schema: patchVendorsQuotasMock(),
  //   delay: 800,
  // },
  // {
  //   url: 'vendors/virtual/store',
  //   apiEndpoint: 'evoqAdmin',
  //   schema: listVirtualVendorsMock(),
  //   useStartsWith: true,
  //   delay: 500,
  // },
  // {
  //   method: 'PATCH',
  //   url: 'vendors/virtual/store',
  //   apiEndpoint: 'evoqAdmin',
  //   schema: patchVirtualVendorsQuotasMock(),
  //   useStartsWith: true,
  //   delay: 800,
  // },
];
